export const HIVOLUME_TINS_API_URL = 'extended-tins/search?search-type=';
export const HIVOLUME_TINS_EXTENDED_API_URL = 'https://uhcinsights-bulk-process-dev.uhc.com/extended-tins-jobs/result/';